import script from "./SmartAd.vue?vue&type=script&setup=true&lang=ts"
export * from "./SmartAd.vue?vue&type=script&setup=true&lang=ts"

import "./SmartAd.vue?vue&type=style&index=0&id=63272fca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63272fca"]])

export default __exports__